<template>
  <div class="audition-student">
    <section>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="试听管理" name="first">
          <el-form style="margin-top: 10px" :inline="true" size="mini">
            <el-form-item label="学员姓名">
              <el-input v-model="form2.realname" placeholder="请输入学员姓名" @keyup.enter.native="search"></el-input>
            </el-form-item>

            <el-form-item label="主责任人">
              <el-select v-model="form2.leader" placeholder="请选择主责任人" style="width: 150px" @change="getAuditionStudentList" clearable>
                <el-option v-for="item in user_list" :key="item.id" :label="item.realname + '(' + item.name + ')'" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="试听状态">
              <el-select v-model="form2.state" placeholder="请选择" style="width: 150px">
                <el-option label="不限" value></el-option>
                <el-option label="试听中-待分配" value="1"></el-option>
                <el-option label="试听中-待上课" value="2"></el-option>
                <el-option label="试听中-已上课" value="3"></el-option>
                <el-option label="已报名" value="4"></el-option>
                <el-option label="试听失败" value="5"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-form>

          <el-divider></el-divider>

          <el-row>
            <el-col :span="24">
              <div>
                <el-button size="mini" type="primary" @click="AddAuditionStudent">新增试听学员</el-button>

                <el-button size="mini" type="primary" @click="FlowClassAudition">安排试听</el-button>

                <el-button size="mini" plain style="margin-left: 10px" @click="deleteStudents">删除</el-button>

                <el-button style="float: right" size="mini" plain @click="OpenMultiAdd">批量导入</el-button>
              </div>
            </el-col>
          </el-row>

          <div class="table-style">
            <el-table size="mini" :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{ background: '#f5f7fa' }">
              <el-table-column type="selection" width="55"></el-table-column>

              <el-table-column fixed="left" label="姓名" width="100">
                <!--TODO 查询试听记录-->
                <template slot-scope="scope">
                  <span style="color: #409eff; cursor: pointer; font-weight: bold" @click="getStudentAuditionTchPlan(scope.row.id)" type="primary">{{ scope.row.studentUserInfo.realname }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="sex" label="性别" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.sex }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" prop="name" label="平台账号" width="100"></el-table-column>

              <el-table-column width="150" align="left" label="联系电话">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.parent_a }}</span>
                  <span>
                    {{ scope.row.studentUserInfo.parent_a_phone_num }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="家长微信">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.parent_b }}</span>
                  <span>
                    {{ scope.row.studentUserInfo.parent_b_phone_num }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" prop="state" label="试听状态" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.state == '1'">试听中-待分配</span>
                  <span v-else-if="scope.row.state == '2'">试听中-待上课</span>
                  <span v-else-if="scope.row.state == '3'">试听中-已上课</span>
                  <span v-else-if="scope.row.state == '4'">已报名</span>
                  <span v-else-if="scope.row.state == '5'">试听失败</span>
                </template>
              </el-table-column>

              <el-table-column align="left" prop="school_name" label="学校名称" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.school_name }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" width="100" label="年级">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.studentUserInfo.gradeStr }}</span> -->
                  <span v-if="scope.row.studentUserInfo.grade == '1'">幼儿园小班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '2'">幼儿园中班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '3'">幼儿园大班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '4'">一年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '5'">二年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '6'">三年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '7'">四年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '8'">五年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '9'">六年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '10'">初一</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '11'">初二</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '12'">初三</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '13'">高一</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '14'">高二</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '15'">高三</span>
                </template>
              </el-table-column>

              <el-table-column align="left" width="100" label="主责任人">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.leaderName }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="所属校区" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.campusName }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" align="center" label="操作" width="100">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="标记为试听成功" placement="top-start">
                    <i @click="updateAutidion_Submit(scope.row.id, '1')" style="font-size: 20px; cursor: pointer" class="el-icon-circle-check"></i>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" content="标记为试听失败" placement="top-start">
                    <i @click="updateAutidion_Submit(scope.row.id, '2')" style="
                        margin-left: 10px;
                        font-size: 20px;
                        cursor: pointer;
                      " class="el-icon-circle-close"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-style">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <!--试听成功_提示框-->
    <el-dialog title="提示" :visible.sync="dialogFormVisible3" width="50%">
      <span>该操作表示学员试听成功,并转为正式学员。是否继续？</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateAutidionSuccess">确 定</el-button>
      </span>
    </el-dialog>

    <!--试听失败_提示框-->
    <el-dialog title="提示" :visible.sync="dialogFormVisible4" width="50%">
      <span>该操作表示学员试听失败,是否继续?</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible4 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateAutidionFailed">确 定</el-button>
      </span>
    </el-dialog>

    <!--添加学员-->
    <el-dialog title="选择试听讲次" :visible.sync="dialogVisible1" width="80%" top="10vh">
      <el-form :inline="true" size="mini">
        <el-form-item label="讲次名称">
          <el-input v-model="form1.title" placeholder="请输入讲次名称" clearable style="width: 200px" @keyup.enter.native="search_plan"></el-input>
        </el-form-item>

        <el-form-item label="班级名称">
          <el-input v-model="form1.classname" placeholder="请输入班级名称" clearable style="width: 200px" @keyup.enter.native="search_plan"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search_plan">查询</el-button>
        </el-form-item>

        <br />

        <el-form-item label="讲次类型">
          <el-select size="mini" v-model="form1.classType" placeholder="请选择" style="width: 150px" @change="getTeachingPlanList">
            <el-option label="常规" value="1"></el-option>
            <el-option label="试听" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select size="mini" v-model="form1.state" placeholder="请选择" style="width: 150px" @change="getTeachingPlanList">
            <el-option label="已上课" value="1"></el-option>
            <el-option label="未上课" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="星期">
          <el-select size="mini" v-model="form1.week" multiple collapse-tags placeholder="请选择" clearable @change="getTeachingPlanList">
            <el-option v-for="item in weeklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时段">
          <el-select size="mini" v-model="form1.time" multiple collapse-tags placeholder="请选择" clearable @change="getTeachingPlanList">
            <el-option v-for="item in timelist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <br />
        <el-form-item label="上课日期">
          <el-date-picker v-model="form1.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="getTeachingPlanList" placement="bottom-start"></el-date-picker>
        </el-form-item>
      </el-form>

      <div class="table-style">
        <el-table size="mini" :data="TeachPlan_tableData" @selection-change="CurrentChange_Teachplan" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column type="selection" width="55"></el-table-column>

          <el-table-column fixed="left" align="left" prop="lessionInfo.title" label="讲次名称" width="150" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column align="left" prop="classInfo.name" label="所属班级" width="150"></el-table-column>

          <el-table-column align="left" prop="classInfo.curriculumInfo.title" label="所属课程" width="200"></el-table-column>

          <el-table-column align="left" prop="lecturerName" label="上课老师" width="100"></el-table-column>

          <el-table-column align="left" label="星期" width="100">
            <template slot-scope="scope">
              <span v-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    0
                ">周日</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    1
                ">周一</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    2
                ">周二</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    3
                ">周三</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    4
                ">周四</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    5
                ">周五</span>
              <span v-else-if="
                  new Date(scope.row.start_class_date.slice(0, 10)).getDay() ==
                    6
                ">周六</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="上课时间" width="200">
            <template slot-scope="scope">
              <span>
                {{ scope.row.start_class_date }} -
                {{ scope.row.end_class_date.slice(10, 20) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="left" width="100" label="状态">
            <template slot-scope="scope">
              <span style="color: green" v-if="scope.row.sign_state == '1'">已上课</span>
              <span v-else-if="scope.row.sign_state == '2'">未上课</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" width="100" label="学员数">
            <template slot-scope="scope">
              <span>{{ scope.row.stuTotalSignNum }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="page_no2" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size2" layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false">取消</el-button>
        <el-button size="small" type="primary" @click="addTeachingPlan">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="80%" title="试听记录" :visible.sync="outerVisible1">
      <div>
        <el-table size="mini" :data="AuditionPlanData" style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column fixed="left" width="150px;" align="center" prop="techPlanInfo.lessionInfo.title" label="讲次名称"></el-table-column>

          <el-table-column align="center" prop="techPlanInfo.classInfo.curriculum_class_type" label="班级类型">
            <template slot-scope="scope">
              <span v-if="
                  scope.row.techPlanInfo.classInfo.curriculum_class_type == '1'
                ">正式班</span>
              <span v-else>试听班</span>
            </template>
          </el-table-column>

          <el-table-column width="200px;" align="center" prop="techPlanInfo.classInfo.name" label="班级名称"></el-table-column>

          <el-table-column width="200px;" align="center" prop="techPlanInfo.start_class_date" label="开始时间"></el-table-column>
          <el-table-column width="200px;" align="center" prop="techPlanInfo.end_class_date" label="结束时间"></el-table-column>

          <el-table-column align="center" prop="techPlanInfo.lecturerName" label="上课老师"></el-table-column>

          <el-table-column align="center" label="出勤">
            <template slot-scope="scope">
              <span v-if="scope.row.sign_state == '1'">出勤</span>
              <span v-else-if="scope.row.sign_state == '2'">缺勤</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="remark" label="备注"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="添加学员" :visible.sync="dialogVisible" width="50%">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-upload action="/" :on-change="onChange" :auto-upload="false" :show-file-list="false" accept=".xls, .xlsx">
              <el-button size="mini">
                导入学员信息
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-tooltip placement="top">
              <div slot="content">
                【注意事项】
                <br />1、学员账号为6-20位字母或数字组成,不能包含特殊字符,推荐以学员家长手机号作为平台账号;
                <br />2、性别统一以中文输入"男"或者"女";
                <br />3、所有字段内容不能为空;
                <br />4、批量导入每次最多导入50人; <br />5、默认密码为{{$store.state.globalCheck.defaultPassword}}
                <br />
                <br />【录入示例】 <br />王晓明 男 18722160555
              </div>
              <el-link style="float: right" icon="el-icon-document" @click="DownLoadExcel">下载Excel模板</el-link>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>

      <el-table size="mini" height="300" :data="outputs" style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#f5f7fa' }" :row-class-name="tableRowClassName">
        <el-table-column prop="realname" label="姓名" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" align="center"></el-table-column>
        <el-table-column prop="username" label="账号" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="Deleteoutputs(scope.$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ClearMultiStudent">暂不添加</el-button>

        <el-button size="small" type="primary" @click="MultiAddStudent">确认添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAuditionStudentList,
  updateAutidionSuccess,
  updateAutidionFailed,
  getCampusAllCurriculumtList,
  getTeachingPlanList,
  addAuditionStuToTeachingPlan,
  getStudentAuditionTchPlan,
  getCampusUserList,
  deleteStudents,
  bulkAddAuditionStudent,
} from '@/api/educational.js'
import XLSX from 'xlsx'
export default {
  name: 'auditionstudent',
  data() {
    return {
      //TODO 跟班试听变量
      //跟班试听
      dialogVisible1: false,
      form1: {
        state: '2',
        classType: '2',
      },
      TeachPlan_tableData: [], //讲次列表
      chooseStudents: [], //试听学员列表选择
      choosePlan_current: [], //选择的讲次ID组
      chooseStu_current: [], //选择的学员ID组
      target_school: {}, // 目标校区
      weeklist: [
        { id: 1, name: '周一' },
        { id: 2, name: '周二' },
        { id: 3, name: '周三' },
        { id: 4, name: '周四' },
        { id: 5, name: '周五' },
        { id: 6, name: '周六' },
        { id: 0, name: '周日' },
      ],
      timelist: [
        {
          id: 1,
          name: '上午',
        },
        {
          id: 2,
          name: '下午',
        },
        {
          id: 3,
          name: '晚上',
        },
      ],
      statelist: [
        { id: 1, name: '已上课' },
        { id: 2, name: '未上课' },
      ],

      //页码管理
      page_no2: 1,
      page_size2: 10,
      total2: 0,

      //意向学员转公开课试听学员
      state: '1',
      form2: {
        realname: '',
        state: '',
        leader: '',
      },

      //试听学员操作
      chooseStudentId: '',

      form: {
        nickname: '',
        student_user_id: '', //学生ID
        curriculum_class_id: '', //班级ID
        other_goods_list: [], //其他商品列表
        remark: '', //备注
        chooseClassinfo: {},
        chooseGoods: [],
      },
      formLabelWidth: '120px',
      chooseTeachPlanList: [],

      num: '1',
      input: '0',

      dialogFormVisible3: false, //试听成功提示信息
      dialogFormVisible4: false, //试听失败提示信息
      outerVisible1: false, //试听记录
      AuditionPlanData: [], //试听记录
      activeName: 'first',
      name: '',
      status: '全部',
      timeScope: '',
      tableData: [],

      page_no: 1,
      page_size: 20,
      total: 0,

      Goodslist: [],
      goodslist: [],

      //订单state
      order_state: '',

      course_list: [],
      user_list: [],

      //批量导入试听学员
      outputs: [],
      dialogVisible: false,
      fileData: [], //文件信息
      has_error: false, //检验输入规范
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue) {
        console.log('校区监听')

        if (newValue.length == 0) {
          this.$message.warning('请选择校区')
        } else {
          this.getAuditionStudentList()
        }

        if (newValue.length == 1) {
          this.getCampusUserList()
        } else {
          this.user_list = []
          this.form2.leader = ''
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning('请选择校区')
    } else {
      this.getAuditionStudentList()
      if (this.$store.state.user.selected_schools.length == 1) {
        this.getCampusUserList()
      }
    }
  },
  methods: {
    getCampusUserList() {
      console.log('校区ID')
      this.form2.leader = ''
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    //查询学员试听记录
    getStudentAuditionTchPlan(id) {
      getStudentAuditionTchPlan({
        student_user_id: id,
      }).then((res) => {
        console.log('查询试听记录')
        console.log(res)
        this.outerVisible1 = true
        this.AuditionPlanData = res.stuTchPlanList
      })
    },

    //TODO 跟班试听函数
    CurrentChange_Teachplan(val) {
      console.log('选择了跟班试听讲次')
      console.log(val)
      this.choosePlan_current = []

      for (let k = 0; k < val.length; k++) {
        this.choosePlan_current.push(val[k].id)
      }
    },

    //点击跟班试听
    FlowClassAudition() {
      if (this.$store.state.user.selected_schools.length > 1) {
        this.$message.warning('请选择1个目标校区')
      } else {
        if (this.chooseStudents.length == 0) {
          this.$message.warning('请选择试听学员')
        } else {
          this.dialogVisible1 = true
          this.getTeachingPlanList()
        }
      }
    },

    //选择学员
    handleSelectionChange(selection) {
      this.chooseStudents = selection
      console.log('试听学员列表')
      console.log(this.chooseStudents)

      this.chooseStu_current = []

      for (let k = 0; k < selection.length; k++) {
        this.chooseStu_current.push(selection[k].id)
      }
    },

    //获取校区的排课信息
    getTeachingPlanList() {
      getTeachingPlanList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        className: this.form1.classname, //班级名称
        title: this.form1.title,
        curriculum_id: this.form1.curriculum_id, //课程体系ID
        start_date: this.form1.date ? this.form1.date[0] : '', // 开始时间
        end_date: this.form1.date ? this.form1.date[1] : '', // 结束时间
        quantum_state: JSON.stringify(this.form1.time),
        week_state: JSON.stringify(this.form1.week),
        sign_state: this.form1.state,
        classType: this.form1.classType,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询校区教学计划')
        console.log(res)
        this.TeachPlan_tableData = res.teachingPlan
        this.total2 = res.total
      })
    },

    //查询试听讲次
    search_plan() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请选择校区')
      } else {
        this.page_no2 = 1
        this.getTeachingPlanList()
      }
    },

    //TODO 跟班试听讲次
    addTeachingPlan() {
      console.log('试听学员讲次参数')
      console.log(this.chooseStu_current)
      console.log(this.choosePlan_current)

      this.addAuditionStuToTeachingPlan()
    },

    //添加跟班试听讲次
    addAuditionStuToTeachingPlan() {
      addAuditionStuToTeachingPlan({
        teachingIds: JSON.stringify(this.choosePlan_current),
        studentIds: JSON.stringify(this.chooseStu_current),
      }).then((res) => {
        console.log('添加跟班试听讲次')
        console.log(res)
        if (res.is_update) {
          if (res.failStuArr.length > 0) {
            for (let k = 0; k < res.failStuArr.length; k++) {
              setTimeout(() => {
                this.$notify({
                  title: '警告',
                  message:
                    this.chooseStudents[k].studentUserInfo.realname +
                    ',' +
                    res.failStuArr[k].msg,
                  type: 'warning',
                })
              }, 100)
            }
          } else {
            this.$message.success('成功安排试听讲次')
            this.dialogVisible1 = false
          }
        }
      })
    },

    //查询试听学员
    getAuditionStudentList() {
      getAuditionStudentList({
        realname: this.form2.realname,
        leader: this.form2.leader,
        state: this.form2.state,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询试听学员')
        console.log(res)
        this.tableData = res.studentList
        this.total = res.total
      })
    },

    AddAuditionStudent() {
      if (
        this.$store.state.user.selected_schools.length == 0 ||
        this.$store.state.user.selected_schools.length > 1
      ) {
        this.$message.warning('请选择1个目标校区')
      } else {
        this.$router.push({
          name: 'input-auditionstudent',
        })
      }
    },

    updateAutidion_Submit(id, cmd) {
      this.chooseStudentId = id
      console.log('当前操作的学员ID')
      console.log(this.chooseStudentId)

      if (cmd == '1') {
        console.log('试听成功操作')

        this.$confirm('确定将该试听学员转化为正式学员吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.updateAutidionSuccess()
        })
      } else {
        console.log('试听失败操作')

        this.$confirm('确定将该试听学员标记为试听失败吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.updateAutidionFailed()
        })
      }
    },

    //试听成功
    updateAutidionSuccess() {
      console.log('试听学员的ID')
      console.log(this.chooseStudentId)

      updateAutidionSuccess({
        studentUserId: this.chooseStudentId,
      }).then((res) => {
        console.log('试听成功')
        console.log(res)
        this.$message.success('试听成功')
        this.dialogFormVisible3 = false
        this.getAuditionStudentList()
      })
    },
    //试听失败
    updateAutidionFailed() {
      updateAutidionFailed({
        studentUserId: this.chooseStudentId,
      }).then((res) => {
        console.log('试听失败')
        console.log(res)
        this.dialogFormVisible4 = false
        this.$message.success('试听失败')
        this.getAuditionStudentList()
      })
    },

    search() {
      this.page_no = 1
      this.getAuditionStudentList()
    },
    handleClick() { },
    handleSizeChange(val) {
      this.page_size = val
      this.getAuditionStudentList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getAuditionStudentList()
    },
    editStudent() { },

    //获得分校课程体系
    getCampusAllCurriculumtList() {
      getCampusAllCurriculumtList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得分校所有课程体系')
        console.log(res)

        this.course_list = res.campusCurriculumList
      })
    },

    deleteStudents() {
      if (this.chooseStu_current.length == 0) {
        this.$message({
          message: '请选择要删除的试听学员',
          type: 'warning',
        })
        return
      }

      this.$confirm('确定要删除选中的试听学员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteStudents({
          studentIds: JSON.stringify(this.chooseStu_current),
        }).then((res) => {
          console.log('删除试听学员')
          console.log(res)

          if (res.is_delete) {
            if (res.failArr.length == 0) {
              this.$message.success('删除成功')
            } else {
              for (let k = 0; k < res.failArr.length; k++) {
                this.$notify({
                  title:
                    '警告:' + this.chooseStudents[k].studentUserInfo.realname,
                  message: res.failArr[k].failReason,
                  type: 'warning',
                  duration: 0,
                })
              }
            }
            this.getAuditionStudentList()
          }
        })
      })
    },

    checkSpecialKey(str) {
      let specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false
        }
      }
      return true
    },

    //打开批量导入窗口

    OpenMultiAdd() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请在左上角,选择目标校区')
        return
      } else if (this.$store.state.user.selected_schools.length > 1) {
        this.$message.warning('请在左上角,选择1个目标校区')
        return
      }

      this.dialogVisible = true
    },

    //移除批量导入学员
    Deleteoutputs(index) {
      console.log('移除批量导入学员')
      this.outputs.splice(index, 1)
    },

    //确认添加
    MultiAddStudent() {
      console.log('确认添加学员')
      console.log(this.outputs)
      this.has_error = false

      if (this.outputs.length == 0) {
        this.$message.warning('请录入学员信息')
        return
      } else if (this.outputs.length > 50) {
        this.$message.warning('单次批量添加学员,最大数量为50人')
        return
      } else {
        for (let k = 0; k < this.outputs.length; k++) {
          this.checkUsername(this.outputs[k].username)
          this.checkRealname(this.outputs[k].realname)
          this.checkSex(this.outputs[k].sex)
        }

        if (this.has_error) {
          return
        }

        var stuArr = [] //学员信息
        var stu = {
          realname: '',
          name: '',
          sex: '',
          campusId: '',
        }

        for (let k = 0; k < this.outputs.length; k++) {
          stu = {
            realname: this.outputs[k].realname,
            name: this.outputs[k].username,
            sex: this.outputs[k].sex,
            campusId: this.$store.state.user.selected_schools[0],
          }

          stuArr.push(stu)
        }

        console.log('批量导入学员信息')
        console.log(stuArr)

        bulkAddAuditionStudent({
          stuArr: JSON.stringify(stuArr),
        }).then((res) => {
          console.log('批量导入学员')
          console.log(res)
          if (res.is_create) {
            if (res.failArr.length == 0) {
              this.$message.success('添加成功')
              this.dialogVisible = false
            } else {
              console.log('添加失败')
              for (let k = 0; k < res.failArr.length; k++) {
                setTimeout(() => {
                  this.$notify({
                    title: '警告',
                    message:
                      this.outputs[k].realname + ',' + res.failArr[k].msg,
                    type: 'warning',
                  })
                }, 100)
              }
              //取数组交集,仅保留失败的数据
            }

            this.$message.success(
              '导入成功' +
              (this.outputs.length -
                res.failArr.length +
                '个,' +
                '失败' +
                res.failArr.length +
                '个')
            )
            this.getAuditionStudentList()
          }
        })
      }
    },

    //清除批量导入学员
    ClearMultiStudent() {
      this.outputs = []
      this.dialogVisible = false
    },

    //下载Excel模板

    DownLoadExcel() {
      window.open(
        'https://wugecdn.steam.fun/resources/static/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E5%AD%A6%E5%91%98.xls',
        '_blank'
      )
    },

    //更新表格状态
    tableRowClassName({ row, rowIndex }) {
      console.log('表格信息')
      console.log(row)
      console.log(rowIndex)

      if (this.checkUsername(row.username)) {
        return ''
      } else {
        return 'warning-row'
      }
    },

    //批量导入功能
    //文件选择时
    onChange(file, fileList) {
      this.fileData = file // 保存当前选择文件
      console.log(fileList)
      this.readExcel() // 调用读取数据的方法
    },

    //读取文件数据
    readExcel(e) {
      let that = this
      console.log(e)
      const files = that.fileData
      if (!files) {
        //如果没有文件
        return false
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          //导入的文件名称
          console.log(workbook.SheetNames)
          const wsname = workbook.SheetNames[0] //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) //生成json表格内容
          that.outputs = [] //清空接收数据
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              //此处的字段名对应 上面表格数据的字段名
              realname: ws[i]['姓名'],
              sex: ws[i]['性别'],
              username: ws[i]['账号'],
            }
            that.outputs.push(sheetData)
          }
          console.log('导入的学员')
          console.log(that.outputs)
        } catch (e) {
          console.log(e)
          return false
        }
      }
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw)
    },

    //检测账号规范

    checkUsername(value) {
      if (!value) {
        this.$message.warning('账号不能为空')
        this.has_error = true
        return false
      }
      if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) {
        this.$message.warning('账号必须为6-20位字母或数字组成')
        this.has_error = true
        return false
      }
      if (!this.checkSpecialKey(value)) {
        this.$message.warning('不能含有特殊字符！！')
        this.has_error = true
        return false
      }

      return true
    },

    checkRealname(value) {
      if (!value) {
        this.$message.warning('姓名不能为空')
        this.has_error = true
        return false
      }
      if (!this.checkSpecialKey(value)) {
        this.$message.warning('不能含有特殊字符！！')
        this.has_error = true
        return false
      }
    },

    checkSex(value) {
      if (!value) {
        this.$message.warning('性别不能为空')
        this.has_error = true
        return false
      }
      if (value !== '男' && value !== '女') {
        this.$message.warning("性别请填'男' 或 '女'")
        this.has_error = true
        return false
      }
    },

    //页码管理
    handleSizeChange2(val) {
      this.page_size2 = val
      this.getTeachingPlanList()
    },
    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getTeachingPlanList()
    },
  },
}
</script>

<style lang="scss" scoped>
.audition-student {
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .table-style {
      margin-top: 20px;
    }
  }
  .form-style-open {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>

<style>
.audition-student .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}
</style>
